import React from "react";
import { Box, Typography, Paper, Button, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";

export default function TransferResult({ status = "success" }) {
  const isSuccess = status === "success";

  const data = {
    amount: "₹1505.90",
    name: "Rahul Sharma",
    bank: "HDFC Bank",
    ref: "TXN9876543210",
    date: "7/1/2026",
    message: isSuccess
      ? "Your payment of ₹1505.90 has been sent to Rahul Sharma."
      : "Your payment could not be completed. Please try again.",
  };

  const navigate = useNavigate();
  const navigatetodashboard = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <DashboardHeader />

      <Box
        minHeight="100vh"
        bgcolor="#f8fafc"
        display="flex"
        alignItems="center"
        justifyContent="center"
        px={2}
      >
        <Box width="100%" maxWidth={520} textAlign="center">
          {isSuccess ? (
            <CheckCircleIcon sx={{ fontSize: 64, color: "#22c55e", mb: 2 }} />
          ) : (
            <CancelIcon sx={{ fontSize: 64, color: "#ef4444", mb: 2 }} />
          )}

          <Typography variant="h5" fontWeight="bold">
            {isSuccess ? "Transfer Successful" : "Transfer Failed"}
          </Typography>

          <Typography color="text.secondary" mt={1} mb={4}>
            {data.message}
          </Typography>

          <Paper sx={{ p: 3, borderRadius: 3, mb: 4 }}>
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Typography fontSize={12} color="text.secondary">
                  AMOUNT
                </Typography>
                <Typography variant="h5" fontWeight="bold">
                  {data.amount}
                </Typography>
              </Box>

              <Box>
                <IconButton>
                  <DownloadIcon />
                </IconButton>
                <IconButton>
                  <ShareIcon />
                </IconButton>
              </Box>
            </Box>

            <Box mt={3} display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
              <Info label="BENEFICIARY" value={data.name} />
              <Info label="BANK" value={data.bank} />
              <Info label="REF NO." value={data.ref} />
              <Info label="DATE" value={data.date} />
            </Box>
          </Paper>

          <Box display="flex" gap={2} mb={3}>
            <Button
              fullWidth
              sx={{
                bgcolor: isSuccess ? "#22c55e" : "#0f172a",
                color: "white",
                py: 1.5,
                borderRadius: 2,
                "&:hover": {
                  bgcolor: isSuccess ? "#16a34a" : "#020617",
                },
              }}
              onClick={() => {
                if (isSuccess) {
                  navigate("/dashboard");
                } else {
                  navigate("/dashboard/transfertobank"); 
                }
              }}
            >
              {isSuccess ? "Back to Dashboard" : "Try Again"}
            </Button>

            <Button
              fullWidth
              sx={{
                bgcolor: "#0f172a",
                color: "white",
                py: 1.5,
                borderRadius: 2,
              }}
            >
              Repeat Transfer ↗
            </Button>
          </Box>

          <Typography fontSize={13} color="text.secondary">
            Need help?{" "}
            <Typography component="span" color="#22c55e" fontWeight="bold">
              Raise a Dispute
            </Typography>
          </Typography>
        </Box>
      </Box>
    </>
  );
}

function Info({ label, value }) {
  return (
    <Box>
      <Typography fontSize={11} color="text.secondary">
        {label}
      </Typography>
      <Typography fontWeight="500">{value}</Typography>
    </Box>
  );
}
